import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box, Flex } from '../../../../units/Box/Box';
import Button from '../../../../units/Button/Button';

import { FormTitle } from '../../FormUnits/FormUnits';

const InfoBox = styled(Box)`
  font-family: ${props => props.theme.fonts.regular};
  height: 500px;
  overflow-y: scroll;

  & ::-webkit-scrollbar {
    margin-right: 1px;
    width: 4px;
    height: 4px;
    background-color: ${props => props.theme.colors.white};
  }

  & ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: rgba(4, 100, 255, 0.38);
  }

  & a {
    color: ${props => props.theme.colors.link};
    text-decoration: underline;
  }
`;

const UserInfoForm = ({ fields, applyAction, renderHeader, params }) => {
  const close = () => {
    applyAction({
      actionId: '_close'
    });
  };

  const Title = () => (
    <Box>
      <FormTitle className="form-title_user-information">
        {params.title}
      </FormTitle>
    </Box>
  );

  return (
    <Box>
      {renderHeader({ title: <Title /> })}
      <InfoBox
        className="UserInfoForm__InfoBox"
        dangerouslySetInnerHTML={{ __html: fields.text.value }}
      />
      <Flex mt="25px" justify="flex-end">
        <Button size="medium" font="caption" onClick={close} bold>
          Закрыть{' '}
        </Button>{' '}
      </Flex>{' '}
    </Box>
  );
};

UserInfoForm.propTypes = {
  applyAction: PropTypes.func.isRequired,
  renderHeader: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired
};

export default UserInfoForm;



// WEBPACK FOOTER //
// ./src/components/containers/Forms/FormsComponents/UserInfoForm/UserInfoForm.js